export enum ServerKeysStatus {
    Active = 1,
    Revoked = 2,
    Deleted = 3}

export function isActive(status: ServerKeysStatus) {
    return status === ServerKeysStatus.Active;
}